import { useEffect, useState } from 'react';
import Company from '../interfaces/Company';
import User from '../interfaces/User';
import { getCompany } from '../services/companyService';

const useCompany = (user: User | null) => {
  const [companyDetails, setCompanyDetails] = useState<Company>();

  useEffect(() => {
    const getCompanyDetails = async (user: User) => {
      if (!user.company_id) {
        return;
      }

      const result = (await getCompany(user.company_id))?.message;
      setCompanyDetails(result);
    };

    if (user) {
      getCompanyDetails(user);
    }
  }, [user]);

  return { companyDetails };
};

export default useCompany;
